<div class="custom-row">
  <!-- @if(mode==="edit"){
    <ppl-button 
    label="Cancel" 
    icon="fa fa-ban" 
    [customClass]="'alt-button'" 
    [iconPosition]="'left'"
    (click)="cancelEdit()"
    ></ppl-button>    

    <ppl-button 
    label="Save" 
    icon="fa fa-floppy-o" 
    [customClass]="'alt-button'" 
    [iconPosition]="'left'"
    (click)="save()"
    ></ppl-button>
  } -->
  @if(mode==="read" && leadStatus !== approvedStatus && !(entry === 'referral' && (leadStatus === 'Review Complete' || leadStatus === deniedStatus)) && !readOnly && showEdit){
  <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
    (click)="editInfo()" *authorize="[pageId, tabId, 'CommunicationInformation', 'section', 'edit']"></ppl-button>

  <!-- <span
    (click)="editInfo()"
    nz-icon
    nzType="edit"
    nzTheme="outline"
    *authorize="[pageId, tabId, 'CommunicationInformation', 'section', 'edit']"
  ></span> -->
  }
</div>
@if(mode==="edit"){
<div class="ppl-mt20">
  <form nz-form nz-row [formGroup]="preferncesForm" class="ppl-p0">
    @if(isAttrAvailable('contactType')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactType"
          class="ppl-form-label ">{{getAttributes('contactType').label}}
          @if(getAttributes('contactType').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div [ngClass]="{'error': validationErrors['contactType'] }">
            <ppl-dropdown-select formControlName="contactType" id="contactType" [options]="contactType"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [arialabel]="getAttributes('contactType').mandatory === 'Y' 
                ? getAttributes('contactType').label + ', required'  
                : getAttributes('contactType').label"
              [attr.aria-invalid]="validationErrors['contactType'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['contactType'] ? 'contactType-error' : null">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['contactType']) {
          <span class="pl-1 error-message" id="contactType-error" role="alert">{{validationErrors['contactType']}}</span>
          }
        </nz-form-control>
      </nz-row>

    </nz-form-item>
    }
    @if(preferncesForm.get('contactType')?.value === 'OTH'){
    @if(isAttrAvailable('contactFirstName')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactFirstName" class="ppl-form-label ">
          {{getAttributes('contactFirstName').label}}
          @if(getAttributes('contactFirstName').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('contactFirstName').tooltip}}" nzTooltipPlacement="topRight"
            nz-input formControlName="contactFirstName" id="contactFirstName"
            placeholder="{{getAttributes('contactFirstName').placeholder}}"
            [ngClass]="{'error': validationErrors['contactFirstName'] }" 
            [attr.aria-invalid]="validationErrors['contactFirstName'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['contactFirstName'] ? 'contactFirstName-error' : null"/>
          @if (validationErrors['contactFirstName']) {
          <span class="pl-1 error-message" id="contactFirstName-error" role="alert">{{validationErrors['contactFirstName']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(isAttrAvailable('contactLastName')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactLastName" class="ppl-form-label ">
          {{getAttributes('contactLastName').label}}
          @if(getAttributes('contactLastName').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('contactLastName').tooltip}}" nzTooltipPlacement="topRight"
            nz-input formControlName="contactLastName" id="contactLastName"
            placeholder="{{getAttributes('contactLastName').placeholder}}"
            [ngClass]="{'error': validationErrors['contactLastName'] }" 
            [attr.aria-invalid]="validationErrors['contactLastName'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['contactLastName'] ? 'contactLastName-error' : null"/>
          @if (validationErrors['contactLastName']) {
          <span class="pl-1 error-message" id="contactLastName-error" role="alert">{{validationErrors['contactLastName']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(isAttrAvailable('contactEmail')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactEmail" class="ppl-form-label ">
          {{getAttributes('contactEmail').label}}
          @if(getAttributes('contactEmail').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('contactEmail').tooltip}}" nzTooltipPlacement="topRight"
            nz-input formControlName="contactEmail" id="contactEmail"
            placeholder="{{getAttributes('contactEmail').placeholder}}"
            [ngClass]="{'error': validationErrors['contactEmail'] }"
            [attr.aria-invalid]="validationErrors['contactEmail'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['contactEmail'] ? 'contactEmail-error' : null" />
          @if (validationErrors['contactEmail']) {
          <span class="pl-1 error-message" id="contactEmail-error" role="alert">{{validationErrors['contactEmail']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(isAttrAvailable('contactPhone')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactPhone" class="ppl-form-label ">
          {{getAttributes('contactPhone').label}}
          @if(getAttributes('contactPhone').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('contactPhone').tooltip}}" nzTooltipPlacement="topRight"
            nz-input formControlName="contactPhone" id="contactPhone"
            placeholder="{{getAttributes('contactPhone').placeholder}}"
            [ngClass]="{'error': validationErrors['contactPhone'] }"
            [attr.aria-invalid]="validationErrors['contactPhone'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['contactPhone'] ? 'contactPhone-error' : null" />
          @if (validationErrors['contactPhone']) {
          <span class="pl-1 error-message" id="contactPhone-error" role="alert">{{validationErrors['contactPhone']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    }

    @if(isAttrAvailable('availabilityDays')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="availabilityDays" class="ppl-form-label ">{{
          getAttributes('availabilityDays').label }}
          @if(getAttributes('availabilityDays').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('availabilityDays').tooltip}}" nzTooltipPlacement="topRight">
          <div [formGroup]="preferncesForm">
            <div formArrayName="availabilityDays">
              <ng-container>
                @for(day of daysOfWeek; track $index){
                <label nz-checkbox [formControlName]="$index" [attr.aria-label]="shortToFullDayMap[day]">
                  {{ day }}
                </label>
                }
              </ng-container>
            </div>
            <span class="error-message">
              {{ validationErrors['availabilityDays'] }}
            </span>
          </div>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="availabilityTimingStart" class="ppl-form-label ">{{
          getAttributes('availabilityTimingStart').label }}
          @if(getAttributes('availabilityTimingStart').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-col>
          <div [ngClass]="{'error': validationErrors['availabilityTimingStart'] }"
            [ngClass]="{'error': validationErrors['availabilityTimingEnd'] }">
            <p-calendar class="p-calendar-time" formControlName="availabilityTimingStart" id="availabilityTimingStart"
              [placeholder]="getAttributes('availabilityTimingStart').placeholder" [hourFormat]="'12'" [stepMinute]="15"
              [showTime]="true" [timeOnly]="true" inputStyleClass="p-inputtext-sm p-inputtext"></p-calendar>
            <p-calendar formControlName="availabilityTimingEnd" id="availabilityTimingEnd"
              [placeholder]="getAttributes('availabilityTimingEnd').placeholder" [hourFormat]="'12'" [stepMinute]="15"
              [showTime]="true" [timeOnly]="true" inputStyleClass="p-inputtext-sm p-inputtext"></p-calendar>
          </div>
          @if (validationErrors['availabilityTimingStart'] || validationErrors['availabilityTimingEnd']) {
          <span class="pl-1 error-message">{{validationErrors['availabilityTimingStart'] ?
            validationErrors['availabilityTimingStart'] : validationErrors['availabilityTimingEnd']}}</span>
          }
        </nz-col>


      </nz-row>
    </nz-form-item>
    }

    @if(isAttrAvailable('distanceWillingToTravel')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="distanceWillingToTravel"
          class="ppl-form-label ">{{getAttributes('distanceWillingToTravel').label}}</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('distanceWillingToTravel').tooltip}}"
            nzTooltipPlacement="topRight" nz-input formControlName="distanceWillingToTravel"
            id="distanceWillingToTravel" placeholder="{{getAttributes('distanceWillingToTravel').placeholder}}"
            [ngClass]="{'error': validationErrors['distanceWillingToTravel'] }" />
          <!-- @if (validationErrors['distanceWillingToTravel']) { -->
          <span class="pl-1 error-message">{{validationErrors['distanceWillingToTravel']}}</span>
          <!-- } -->
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if(isAttrAvailable('emergencyContactFirstName')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="emergencyContactFirstName" class="ppl-form-label ">
          {{getAttributes('emergencyContactFirstName').label}}
          @if(getAttributes('emergencyContactFirstName').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('emergencyContactFirstName').tooltip}}"
            nzTooltipPlacement="topRight" nz-input formControlName="emergencyContactFirstName"
            id="emergencyContactFirstName" maxlength="20"
            placeholder="{{getAttributes('emergencyContactFirstName').placeholder}}"
            [ngClass]="{'error': validationErrors['emergencyContactFirstName'] }"
            [attr.aria-invalid]="validationErrors['emergencyContactFirstName'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['emergencyContactFirstName'] ? 'emergencyContactFirstName-error' : null" />
          @if (validationErrors['emergencyContactFirstName']) {
          <span class="pl-1 error-message" id="emergencyContactFirstName-error" role="alert">{{validationErrors['emergencyContactFirstName']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(isAttrAvailable('emergencyContactLastName')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="emergencyContactLastName" class="ppl-form-label ">
          {{getAttributes('emergencyContactLastName').label}}
          @if(getAttributes('emergencyContactLastName').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('emergencyContactLastName').tooltip}}"
            nzTooltipPlacement="topRight" nz-input formControlName="emergencyContactLastName"
            id="emergencyContactLastName" maxlength="20"
            placeholder="{{getAttributes('emergencyContactLastName').placeholder}}"
            [ngClass]="{'error': validationErrors['emergencyContactLastName'] }" 
            [attr.aria-invalid]="validationErrors['emergencyContactLastName'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['emergencyContactLastName'] ? 'emergencyContactLastName-error' : null"/>
          @if (validationErrors['emergencyContactLastName']) {
          <span class="pl-1 error-message" id="emergencyContactLastName-error" role="alert">{{validationErrors['emergencyContactLastName']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    <!-- @if(isAttrAvailable('contactEmail')){
              <nz-form-item  nz-col nzSpan="12" [nzXs]="24"  class="ppl-form-item">
                <nz-row>
                  <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactEmail" class="ppl-form-label ">
                    {{getAttributes('contactEmail').label}}
                    @if(getAttributes('contactEmail').mandatory === 'Y'){
                      <span [attr.aria-label]="'Required'">*</span>
                      }</nz-form-label>
                <nz-form-control class="ppl-form-control">
                  <input nz-tooltip nzTooltipTitle="{{getAttributes('contactEmail').tooltip}}" nzTooltipPlacement="topRight"
                    nz-input formControlName="contactEmail" id="contactEmail"
                    placeholder="{{getAttributes('contactEmail').placeholder}}" [ngClass]="{'error': validationErrors['contactEmail'] }" />
                    @if (validationErrors['contactEmail']) {
                      <span class="pl-1 error-message">{{validationErrors['contactEmail']}}</span>
                    }
                </nz-form-control>
                </nz-row>
              </nz-form-item>
              } -->
    @if(isAttrAvailable('emergencyContactPhone')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="emergencyContactPhone" class="ppl-form-label ">
          {{getAttributes('emergencyContactPhone').label}}
          @if(getAttributes('emergencyContactPhone').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('emergencyContactPhone').tooltip}}"
            nzTooltipPlacement="topRight" nz-input formControlName="emergencyContactPhone" id="emergencyContactPhone"
            placeholder="{{getAttributes('emergencyContactPhone').placeholder}}"
            [ngClass]="{'error': validationErrors['emergencyContactPhone'] }"
            [attr.aria-invalid]="validationErrors['emergencyContactPhone'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['emergencyContactPhone'] ? 'emergencyContactPhone-error' : null" />
          @if (validationErrors['emergencyContactPhone']) {
          <span class="pl-1 error-message" id="emergencyContactPhone-error" role="alert">{{validationErrors['emergencyContactPhone']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(isAttrAvailable('emergencyContactEmail')){
      <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="emergencyContactEmail" class="ppl-form-label ">
            {{getAttributes('emergencyContactEmail').label}}
            @if(getAttributes('emergencyContactEmail').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control">
            <input nz-tooltip nzTooltipTitle="{{getAttributes('emergencyContactEmail').tooltip}}"
              nzTooltipPlacement="topRight" nz-input formControlName="emergencyContactEmail" id="emergencyContactEmail"
              placeholder="{{getAttributes('emergencyContactEmail').placeholder}}"
              [ngClass]="{'error': validationErrors['emergencyContactEmail'] }"
              [attr.aria-invalid]="validationErrors['emergencyContactEmail'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['emergencyContactEmail'] ? 'emergencyContactEmail-error' : null" />
            @if (validationErrors['emergencyContactEmail']) {
            <span class="pl-1 error-message" id="emergencyContactEmail-error" role="alert">{{validationErrors['emergencyContactEmail']}}</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>
      }
    @if(isAttrAvailable('isAvailableForEmergencies')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="isAvailableForEmergencies"
          class="ppl-form-label ">{{getAttributes('isAvailableForEmergencies').label}}
          @if(getAttributes('isAvailableForEmergencies').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isAvailableForEmergencies')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group [ngClass]="{'error': validationErrors['isAvailableForEmergencies'] }"
              formControlName="isAvailableForEmergencies" class="ppl-radio-group" nzId="isAvailableForEmergencies"
              [attr.aria-invalid]="validationErrors['isAvailableForEmergencies'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['isAvailableForEmergencies'] ? 'isAvailableForEmergencies-error' : null">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isAvailableForEmergencies']) {
          <span class="pl-1 error-message" id="isAvailableForEmergencies-error" role="alert">{{validationErrors['isAvailableForEmergencies']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }


    @if(isAttrAvailable('dayEmergencyAvailablity')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="dayEmergencyAvailablity"
          class="ppl-form-label ">{{getAttributes('dayEmergencyAvailablity').label}}
          @if(getAttributes('dayEmergencyAvailablity').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-col class="ppl-form-control">
          <div [ngClass]="{'error': validationErrors['dayEmergencyAvailablity'] }">
            <p-calendar class="p-calendar-time" formControlName="dayEmergencyAvailablityStart"
              id="dayEmergencyAvailablityStart"
              [placeholder]="getAttributes('dayEmergencyAvailablityStart').placeholder" [hourFormat]="'12'"
              [stepMinute]="15" [showTime]="true" [timeOnly]="true"
              inputStyleClass="p-inputtext-sm p-inputtext" />
            <p-calendar formControlName="dayEmergencyAvailablityEnd" id="dayEmergencyAvailablityEnd"
              [placeholder]="getAttributes('dayEmergencyAvailablityEnd').placeholder" [hourFormat]="'12'"
              [stepMinute]="15" [showTime]="true" [timeOnly]="true"
              inputStyleClass="p-inputtext-sm p-inputtext" />
          </div>
          <span class="pl-1 error-message">{{validationErrors['dayEmergencyAvailablityStart'] ?
            validationErrors['dayEmergencyAvailablityStart'] : validationErrors['dayEmergencyAvailablityEnd']}}
          </span>
          <!-- Custom validator error messages for day shift -->
              <span class="pl-1 error-message" *ngIf="preferncesForm.get('dayEmergencyAvailablityStart')?.errors?.['dayStartTimeRequired']">
                Start time is required if end time is set.
              </span>
              <span class="pl-1 error-message" *ngIf="preferncesForm.get('dayEmergencyAvailablityEnd')?.errors?.['dayEndTimeRequired']">
                End time is required if start time is set.
              </span>
              <span class="pl-1 error-message" *ngIf="preferncesForm.get('dayEmergencyAvailablityStart')?.errors?.['dayShiftTimeInvalid'] || preferncesForm.get('dayEmergencyAvailablityEnd')?.errors?.['dayShiftTimeInvalid']">
                Start time must be before end time.
              </span>
              <span class="pl-1 error-message" *ngIf="preferncesForm.get('dayEmergencyAvailablityStart')?.errors?.['dayShiftInvalid'] || preferncesForm.get('dayEmergencyAvailablityEnd')?.errors?.['dayShiftInvalid']">
                Day Emergency Start / End time must be between 6:00 AM and 10:00 PM.
              </span>
        </nz-col>


      </nz-row>

    </nz-form-item>
    }
    @if(isAttrAvailable('nightEmergencyAvailablity')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="nightEmergencyAvailablity"
          class="ppl-form-label  ">{{getAttributes('nightEmergencyAvailablity').label}}
          @if(getAttributes('nightEmergencyAvailablity').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-col class="ppl-form-control">
          <div class="ppl-form-control" [ngClass]="{'error': validationErrors['nightEmergencyAvailablityStart'] }">
            <p-calendar class="p-calendar-time" formControlName="nightEmergencyAvailablityStart" id="nightEmergencyAvailablityStart"
              [placeholder]="getAttributes('nightEmergencyAvailablity').placeholder" [hourFormat]="'12'"
              [stepMinute]="15" [showTime]="true" [timeOnly]="true"
              inputStyleClass="p-inputtext-sm p-inputtext" />
            <p-calendar formControlName="nightEmergencyAvailablityEnd" id="nightEmergencyAvailablityEnd"
              [placeholder]="getAttributes('nightEmergencyAvailablityEnd').placeholder" [hourFormat]="'12'"
              [stepMinute]="15" [showTime]="true" [timeOnly]="true"
              inputStyleClass="p-inputtext-sm p-inputtext" />
          </div>

          <span class="pl-1 error-message">{{validationErrors['nightEmergencyAvailablityStart'] ||
            validationErrors['nightEmergencyAvailablityEnd']}}</span>
          <!-- Custom validator error messages for night shift -->
              <span class="pl-1 error-message" *ngIf="preferncesForm.get('nightEmergencyAvailablityStart')?.errors?.['nightStartTimeRequired']">
                Start time is required if end time is set.
              </span>
              <span class="pl-1 error-message" *ngIf="preferncesForm.get('nightEmergencyAvailablityEnd')?.errors?.['nightEndTimeRequired']">
                End time is required if start time is set.
              </span>
              <span class="pl-1 error-message" *ngIf="preferncesForm.get('nightEmergencyAvailablityStart')?.errors?.['nightShiftTimeInvalid'] || preferncesForm.get('nightEmergencyAvailablityEnd')?.errors?.['nightShiftTimeInvalid']">
                Start time must be before end time.
              </span>
              <span class="pl-1 error-message" *ngIf="preferncesForm.get('nightEmergencyAvailablityStart')?.errors?.['nightShiftInvalid'] || preferncesForm.get('nightEmergencyAvailablityEnd')?.errors?.['nightShiftInvalid']">
                Night Emergency Start / End time must be between 10:00 PM and 6:00 AM.
              </span>
        </nz-col>


      </nz-row>
    </nz-form-item>
    }


    @if(isAttrAvailable('spokenLanguages')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="spokenLanguages"
          class="ppl-form-label ">{{getAttributes('spokenLanguages').label}}
          @if(getAttributes('spokenLanguages').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('spokenLanguages').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['spokenLanguages'] }">
            <ppl-multiselect formControlName="spokenLanguages" id="spokenLanguages" [options]="languages"
              [showClear]="true" placeholder="{{getAttributes('spokenLanguages').label}}" [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'" [attr.aria-invalid]="validationErrors['spokenLanguages'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['spokenLanguages'] ? 'spokenLanguages-error' : null">
            </ppl-multiselect>
          </div>
          @if (validationErrors['spokenLanguages']) {
          <span class="pl-1 error-message" id="spokenLanguages-error" role="alert">{{validationErrors['spokenLanguages']}}</span>
          }
        </nz-form-control>
      </nz-row>

    </nz-form-item>
    }

    @if(isAttrAvailable('primaryLanguage')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="primaryLanguage"
          class="ppl-form-label ">{{getAttributes('primaryLanguage').label}}
          @if(getAttributes('primaryLanguage').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('primaryLanguage').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['primaryLanguage'] }">
            <ppl-dropdown-select formControlName="primaryLanguage" id="primaryLanguage"
              placeholder="{{getAttributes('primaryLanguage').label}}" [options]="languages"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [attr.aria-invalid]="validationErrors['primaryLanguage'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['primaryLanguage'] ? 'primaryLanguage-error' : null"></ppl-dropdown-select>
          </div>
          @if (validationErrors['primaryLanguage']) {
          <span class="pl-1 error-message" id="primaryLanguage-error" role="alert">{{validationErrors['primaryLanguage']}}</span>
          }
        </nz-form-control>
      </nz-row>

    </nz-form-item>
    }

    @if(isAttrAvailable('formLanguage')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="formLanguage"
          class="ppl-form-label ">{{getAttributes('formLanguage').label}}
          @if(getAttributes('formLanguage').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('formLanguage').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['formLanguage'] }">
            <ppl-dropdown-select formControlName="formLanguage" placeholder="{{getAttributes('formLanguage').label}}"
              id="formLanguage" [options]="formLanguages" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [attr.aria-invalid]="validationErrors['formLanguage'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['formLanguage'] ? 'formLanguage-error' : null">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['formLanguage']) {
          <span class="pl-1 error-message" id="formLanguage-error" role="alert">{{validationErrors['formLanguage']}}</span>
          }
        </nz-form-control>
      </nz-row>

    </nz-form-item>
    }



    @if(isAttrAvailable('daysToContact')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="daysToContact" class="ppl-form-label ">{{
          getAttributes('daysToContact').label }}
          @if(getAttributes('daysToContact').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('daysToContact').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [formGroup]="preferncesForm">
            <div formArrayName="daysToContact">
              <ng-container>
                @for(day of daysOfWeek; track $index){
                <label nz-checkbox [formControlName]="$index" [attr.aria-label]="shortToFullDayMap[day]">
                  {{ day }}
                </label>
                }
              </ng-container>
            </div>
            <span class="error-message">
              {{ validationErrors['daysToContact'] }}
            </span>
          </div>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="startContactTime" class="ppl-form-label ">{{
          getAttributes('startContactTime').label }}
          @if(getAttributes('startContactTime').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-col>
          <div [ngClass]="{'error': validationErrors['startContactTime'] }"
            [ngClass]="{'error': validationErrors['endContactTime'] }">
            <ppl-timepicker class="p-calendar-time" formControlName="startContactTime" id="startContactTime"
              [placeholder]="getAttributes('startContactTime').placeholder"></ppl-timepicker>

            <ppl-timepicker formControlName="endContactTime" id="endContactTime"
              [placeholder]="getAttributes('endContactTime').placeholder"></ppl-timepicker>
          </div>
          @if (validationErrors['startContactTime'] || validationErrors['endContactTime']) {
          <span class="pl-1 error-message">{{validationErrors['startContactTime'] ? validationErrors['startContactTime']
            : validationErrors['endContactTime']}}</span>
          }
        </nz-col>


      </nz-row>
    </nz-form-item>
    }
    @if(isAttrAvailable('otherDetails')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="otherDetails"
          class="ppl-form-label ">{{getAttributes('otherDetails').label}}
          @if(getAttributes('otherDetails').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('otherDetails').tooltip}}"
          nzTooltipPlacement="topRight">
          <textarea rows="4" cols="40" nz-input formControlName="otherDetails" id="otherDetails"
            class="ppl-form-control" placeholder="{{getAttributes('otherDetails').placeholder}}"
            [ngClass]="{'error': validationErrors['otherDetails'] }" [attr.aria-invalid]="validationErrors['otherDetails'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['otherDetails'] ? 'otherDetails-error' : null"></textarea>
          @if (validationErrors['otherDetails']) {
          <span class="pl-1 error-message" id="otherDetails-error" role="alert">{{validationErrors['otherDetails']}}</span>
          }
        </nz-form-control>

      </nz-row>

    </nz-form-item>
    }
    @if(isAttrAvailable('specialAccomdation')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="specialAccomdation"
          class="ppl-form-label ">{{getAttributes('specialAccomdation').label}}
          @if(getAttributes('specialAccomdation').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('specialAccomdation').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['specialAccomdation'] }">
            <ppl-dropdown-select formControlName="specialAccomdation" id="specialAccomdation" [options]="accommodations"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" [attr.aria-invalid]="validationErrors['specialAccomdation'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['specialAccomdation'] ? 'specialAccomdation-error' : null">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['specialAccomdation']) {
          <span class="pl-1 error-message" id="specialAccomdation-error" role="alert">{{validationErrors['specialAccomdation']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(preferncesForm.get('specialAccomdation')?.value === 'OTH'){
    @if(isAttrAvailable('specialAccomdationOther')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" zFor="specialAccomdationOther" class="ppl-form-label "></nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('specialAccomdationOther').tooltip}}" nzTooltipPlacement="topRight">
          <textarea nz-tooltip rows="4" nz-input formControlName="specialAccomdationOther" id="specialAccomdationOther"
            placeholder="{{getAttributes('specialAccomdationOther').placeholder}}"
            [ngClass]="{'error': validationErrors['specialAccomdationOther'] }"
            [attr.aria-invalid]="validationErrors['specialAccomdationOther'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['specialAccomdationOther'] ? 'specialAccomdationOther-error' : null"></textarea>
          @if (validationErrors['specialAccomdationOther']) {
          <span class="pl-1 error-message" id="specialAccomdationOther-error" role="alert">{{validationErrors['specialAccomdationOther']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    }
    @if(isAttrAvailable('registerPref')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="registerPref"
          class="ppl-form-label ">{{getAttributes('registerPref').label}}
          @if(getAttributes('registerPref').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('registerPref').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['registerPref'] }">
            <ppl-dropdown-select formControlName="registerPref" id="registerPref" [options]="participantRegisterMode"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [arialabel]="getAttributes('registerPref').mandatory === 'Y' 
                ? getAttributes('registerPref').label + ', required'  
                : getAttributes('registerPref').label"
              [attr.aria-invalid]="validationErrors['registerPref'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['registerPref'] ? 'registerPref-error' : null"></ppl-dropdown-select>
          </div>
          @if (validationErrors['registerPref']) {
          <span class="pl-1 error-message" id="registerPref-error" role="alert">{{validationErrors['registerPref']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }


  </form>
</div>
<div class="custom-row">
  <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="cancelEdit()"></ppl-button>

  <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="save()"></ppl-button>
</div>
}
@else if(mode==="read" && filledInfo && secData){
<div nz-row tabIndex="0">


  @if(isAttrAvailable('contactType')){

  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('contactType').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing"> 
    <span>
      {{filledInfo?.contactType ? getValue(filledInfo?.contactType, 'contact') : filledInfo?.contactType}}
    </span>
    <span *ngIf="!filledInfo?.contactType" class="sr-only">Blank</span>
  </div>

  }
  @if(filledInfo.contactType === 'OTH'){
  @if(isAttrAvailable('contactFirstName')){

  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('contactFirstName').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.contactFirstName}}
    </span>
    <span *ngIf="!filledInfo?.contactFirstName" class="sr-only">Blank</span>
  </div>

  }
  @if(isAttrAvailable('contactLastName')){

  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('contactLastName').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.contactLastName}}
    </span>
    <span *ngIf="!filledInfo?.contactLastName" class="sr-only">Blank</span>
  </div>

  }
  @if(isAttrAvailable('contactEmail')){

  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('contactEmail').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.contactEmail}}
    </span>
    <span *ngIf="!filledInfo?.contactEmail" class="sr-only">Blank</span>
  </div>

  }
  @if(isAttrAvailable('contactPhone')){

  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('contactPhone').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.contactPhone}}
    </span>
    <span *ngIf="!filledInfo?.contactPhone" class="sr-only">Blank</span>
  </div>

  }
  }

  @if(isAttrAvailable('availabilityDays')){

  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('bestTimeToContact').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.bestTimeToContact}}
    </span>
    <span *ngIf="!filledInfo?.bestTimeToContact" class="sr-only">Blank</span>
  </div>

  }

  @if(isAttrAvailable('distanceWillingToTravel')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('distanceWillingToTravel').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.distanceWillingToTravel}}
    </span>
    <span *ngIf="!filledInfo?.distanceWillingToTravel" class="sr-only">Blank</span>
  </div>
  }

  @if(isAttrAvailable('emergencyContactFirstName')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('emergencyContactFirstName').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.emergencyContactFirstName}}
    </span>
    <span *ngIf="!filledInfo?.emergencyContactFirstName" class="sr-only">Blank</span>
  </div>
  }

  @if(isAttrAvailable('emergencyContactLastName')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('emergencyContactLastName').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.emergencyContactLastName}}
    </span>
    <span *ngIf="!filledInfo?.emergencyContactLastName" class="sr-only">Blank</span>
  </div>
  }

  @if(isAttrAvailable('emergencyContactPhone')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('emergencyContactPhone').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.emergencyContactPhone}}
    </span>
    <span *ngIf="!filledInfo?.emergencyContactPhone" class="sr-only">Blank</span>
  </div>
  }
  @if(isAttrAvailable('emergencyContactEmail')){
    <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
      {{getAttributes('emergencyContactEmail').label}}</div>
    <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
      <span>
        {{filledInfo?.emergencyContactEmail}}
      </span>
      <span *ngIf="!filledInfo?.emergencyContactEmail" class="sr-only">Blank</span>
    </div>
  }

  @if(isAttrAvailable('isAvailableForEmergencies')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('isAvailableForEmergencies').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.isAvailableForEmergencies === true ? 'Yes' : 'No' }}
    </span>
    <span *ngIf="!filledInfo?.isAvailableForEmergencies" class="sr-only">Blank</span>
  </div>
  }


  @if(isAttrAvailable('dayEmergencyAvailablity')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('dayEmergencyAvailablity').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{ filledInfo?.emergencyAvailabilityDay}}
    </span>
    <span *ngIf="!filledInfo?.emergencyAvailabilityDay" class="sr-only">Blank</span>
  </div>
  }

  @if(isAttrAvailable('nightEmergencyAvailablity')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('nightEmergencyAvailablity').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{ filledInfo?.emergencyAvailabilityNight}}
    </span>
    <span *ngIf="!filledInfo?.emergencyAvailabilityNight" class="sr-only">Blank</span>
  </div>
  }




  @if(isAttrAvailable('spokenLanguages')){

  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('spokenLanguages').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.spokenLanguages ? getLanguages() : ''}}
    </span>
    <span *ngIf="!filledInfo?.spokenLanguages" class="sr-only">Blank</span>
  </div>

  }
  @if(isAttrAvailable('primaryLanguage')){

  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('primaryLanguage').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.primaryLanguage ? getValue(filledInfo?.primaryLanguage, 'lang') : ''}}
    </span>
    <span *ngIf="!filledInfo?.primaryLanguage" class="sr-only">Blank</span>
  </div>

  }
  @if(isAttrAvailable('formLanguage')){

  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('formLanguage').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.formLanguage ? getValue(filledInfo?.formLanguage, 'lang') : ''}}
    </span>
    <span *ngIf="!filledInfo?.formLanguage" class="sr-only">Blank</span>
  </div>

  }
  @if(isAttrAvailable('daysToContact')){

  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('bestTimeToContact').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.bestTimeToContact}}
    </span>
    <span *ngIf="!filledInfo?.bestTimeToContact" class="sr-only">Blank</span>
  </div>

  }
  @if(isAttrAvailable('otherDetails')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('otherDetails').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.otherDetails}}
    </span>
    <span *ngIf="!filledInfo?.otherDetails" class="sr-only">Blank</span>
  </div>
  }
  @if(isAttrAvailable('specialAccomdation')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('specialAccomdation').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.specialAccomdation ? getLookupValue(accommodations, filledInfo?.specialAccomdation) : ''}}
    </span>
    <span *ngIf="!filledInfo?.specialAccomdation" class="sr-only">Blank</span>
  </div>
  }
  @if(filledInfo.specialAccomdation === 'OTH'){
  @if(isAttrAvailable('specialAccomdationOther')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('specialAccomdationOther').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.specialAccomdationOther}}
    </span>
    <span *ngIf="!filledInfo?.specialAccomdationOther" class="sr-only">Blank</span>
  </div>
  }
  }
  @if(isAttrAvailable('registerPref')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('registerPref').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.registerPref ? getLookupValue(participantRegisterMode, filledInfo?.registerPref) : ''}}
    </span>
    <span *ngIf="!filledInfo?.registerPref" class="sr-only">Blank</span>
  </div>
  }

  @if(isAttrAvailable('showOnDirectory')){
  <div nz-col nzSpan="12" [nzXs]="13" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="font-weight-600 pt-2">
    {{getAttributes('showOnDirectory').label}}</div>
  <div nz-col nzSpan="12" [nzXs]="11" [nzSm]="12" [nzLg]="6" [nzXXl]="6" class="pt-2 mobile-value-left-paddiing">
    <span>
      {{filledInfo?.showOnDirectory ? filledInfo?.showOnDirectory : '-'}}
    </span>
    <span *ngIf="!filledInfo?.showOnDirectory" class="sr-only">Blank</span>
  </div>
  }


</div>
}@else if(mode==="read" && !filledInfo ){
<nz-row >
  <p tabindex="0">No Data found</p>
</nz-row>
}